






















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import {CategroyType, DepthType} from '@/types/product';

@Component({
  components: {PageFormSelect}
})
export default class ProductListCateCascade extends Vue {
  @Prop({required: false, default: 'DISPLAY'}) private readonly categoryType?: string;
  @Prop({required: false, default: false, type: Boolean}) private readonly hideArrow?: boolean;
  @Prop({
    required: false,
    default: function () {
      return [];
    },
    type: Array
  })
  private readonly displayCategorys?: {[propName: string]: any}[];

  private get icoArrow(): string {
    return this.hideArrow ? 'ico_arrow hide-arrow' : 'ico_arrow';
  }

  @Watch('categoryType')
  onCateChange(newVal: string) {
    if (newVal === 'STANDARD') {
      this.depth5Hide = true;
    } else {
      this.depth5Hide = false;
    }
  }

  public categoryNo = '';

  public categoryObj = {
    'categoryCondition.depth': '',
    'categoryCondition.no': ''
  };

  private depth5Hide = false;
  private depthData: DepthType[] = [];

  public setDepthData(depth: number, allData: CategroyType[] = []): void {
    const idx = depth - 1;
    const data: CategroyType[] = [{value: '0', label: depth + 'Depth', children: []}];
    if (allData.length) {
      this.depthData[idx].data = data.concat(allData);
      this.depthData[idx].disabled = false;
    } else {
      this.depthData.push({data, disabled: true});
    }
  }

  public initDepthData(startIdx: number = 0) {
    if (startIdx === 0) {
      this.depthData = [];
      for (let i = 0, length = 5; i < length; i++) {
        this.setDepthData(i + 1);
      }
    } else {
      for (let i = startIdx, length = 5; i < length; i++) {
        const firstItem: CategroyType = {value: '0', label: i + 1 + 'Depth', children: []};
        this.depthData[i].data = [firstItem];
        this.depthData[i].disabled = true;
      }
    }
  }

  public displayCategoryChange(event: any): void {
    const select = event.target;
    const value = select.value;
    const option = select.options[select.selectedIndex];
    const depth = option.getAttribute('depth');

    this.categoryObj['categoryCondition.depth'] = depth;
    this.categoryObj['categoryCondition.no'] = value;
    this.$emit('change', this.categoryObj);
  }

  public change(value: any, event: any): void {
    const depth = event.target.name;
    const depthNo = Number(depth);
    this.categoryObj['categoryCondition.depth'] = depth;
    this.categoryObj['categoryCondition.no'] = value;

    this.$emit('change', this.categoryObj);

    this.initDepthData(depthNo);
    const selectItem = this.depthData[depthNo - 1].data.find((item) => item.value.toString() === value.toString());
    if (selectItem) {
      this.setDepthData(depthNo + 1, selectItem.children);
    } else {
      this.setDepthData(depthNo + 1);
    }
  }

  private created() {
    this.initDepthData();
  }
}
